module.exports = __webpack_public_path__ + "static/media/half_break.bc42c7c6.svg";